export const PublicRoutes = [
  "/",
  "/login",
  "/sobre-nosotros",
  "/Nosotros-Directorio-Anexos",
  "/Nosotros-Organigrama",
  "/consultar-cita-medica",
  "/consultar-resultados-laboratorio",
  "/consulta-externa/laboratorio-resultados",
  "/DirectorioTelefonico",
];

export const MapKeysDefault = [
  {
    id: 1,
    label: "Nosotros",
    iconName: "fa-home",
    submenus: [
      {
        id: 2,
        label: "La institucion",
        iconName: "fa-hospital-alt",
        link: "/sobre-nosotros",
      },
      {
        id: 3,
        label: "Directorio de anexos",
        iconName: "fa-phone-alt",
        link: "/Nosotros-Directorio-Anexos",
      },
      {
        id: 4,
        label: "Organigrama",
        iconName: "fa-project-diagram",
        link: "/Nosotros-Organigrama",
      },
    ],
  },
  {
    id: 5,
    label: "Consulta Externa",
    icon: "fa-stethoscope",
    submenus: [
      {
        id: 6,
        label: "Consultar cita medica",
        icon: "fa-heart-beat",
        link: "/consultar-cita-medica",
      },
      {
        id: 8,
        label: "Consultar resultados de laboratorio",
        icon: "fa-microscope",
        link: "/consultar-resultados-laboratorio",
      },
    ],
  },
];

export const MapKeys = [];
